import IconChevronRight, {
	IconChevronRightProps as _IconChevronRightProps,
} from './IconChevronRight';

export { IconChevronRight };
export type IconChevronRightProps = _IconChevronRightProps;
